import { H2, H4, P } from 'components/Text';
import { Currencies } from 'interfaces/payment';
import { useTranslation } from 'next-i18next/pages';
import { formatNumber } from 'utils/utils';
import { AncillaryType } from 'interfaces/ancillary';
import Ticket from 'components/Ticket';

interface ICartPricesProps {
  numOfPassengers: number;
  sumOfTickets: number;
  paymentCurrency: Currencies;
  serviceFee: number;
  ancillaries: {
    [key in AncillaryType]?: { value: number; piece: number, title: string };
  };
  sumOfAncillaries: number;
  isRoundTrip: boolean;
}

const CartPrices: React.FC<ICartPricesProps> = ({
  numOfPassengers,
  sumOfTickets,
  paymentCurrency,
  serviceFee,
  ancillaries,
  sumOfAncillaries,
  isRoundTrip,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col space-y-1 dm-sans mt-2 mb-12">
      <div className="flex justify-between">
        <Ticket numOfPassengers={numOfPassengers} isRoundTrip={isRoundTrip} />
        <P className="text-right">
          {formatNumber(sumOfTickets)} {paymentCurrency}
        </P>
      </div>

      {ancillaries &&
        Object.entries(ancillaries).map(([k, v]) => {
          return (
            v.piece !== 0 && (
              <div key={v.title} className="flex justify-between">
                <P className="">
                  {t(v.title)}{' '}
                  <span className="text-tt-light-gray-purple">(x{v.piece})</span>
                </P>
                <P key={k} className="text-right">
                  {formatNumber(Math.ceil(v.value))} {paymentCurrency}
                </P>
              </div>
            )
          );
        })}
      <div className="flex justify-between">
        <P>{t('Service fee')}</P>
        <P className="text-right">
          {formatNumber(serviceFee)} {paymentCurrency}
        </P>
      </div>
      <div className="flex justify-between pt-4">
        <div className="flex items-center flex-1">
          <H4 className="flex flex-col sm:flex sm:flex-row mt-2 mt-auto">
            <span className="font-bold"> {t('Total')}</span>
            <span className="sm:ml-2 sm:mt-[0.3rem] text-[0.75rem] text-tt-light-gray-purple">
              {' '}
              ({t('tax included')})
            </span>
          </H4>
        </div>
        <H2 className="flex-[2_2_0%] sm:flex-1 text-tt-dark-purple sm:mt-auto text-right">
          <b>
            {formatNumber(
              sumOfTickets + serviceFee + Math.ceil(sumOfAncillaries),
            )}{' '}
            {paymentCurrency}
          </b>
        </H2>
      </div>
    </div>
  );
};

export default CartPrices;
